<div class="wrapper">
    <main class="middle-content">
        <div class="page_title_block">
            <h1 class="page_title">Transaction Management</h1>
        </div>
        <div class="content-section">
            <div class="outer-box">
                <div class="global-table no-radius p0">
                    <div class="tab-content1">
                        <div class="form-group">
                            <form [formGroup]="searchForm">
                                <div class="row w-100">
                                    <div class="col-md-4">
                                        <div class="filter_search mb20 width100">
                                            <div class="input-group filter_search_group">
                                                <input type="text" class="form-control overflow-text"
                                                    formControlName="search" placeholder="Search" maxlength="60">
                                                <div class="input-group-append">
                                                    <button class="btn btn_search_group" type="button">
                                                        <img src="assets/img/icon-search.png" alt="Search" />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-3">

                                    </div>
                                    <div class="col-md-5">
                                        <div class="form-group row d-flex justify-content-end">
                                            <div class="ms-5 text-align-end text-nowrap" style="text-align: end">
                                                <button type="button" class="btn btn-info link font17 me-3"
                                                    (click)="exportCsv()" style="height: 35px;padding-top: 3px;">
                                                    <i class="fa fa-download" aria-hidden="true"> Download Report
                                                    </i>
                                                </button>

                                                <!-- <a class="link font17"><i class="fas fa-plus-circle me-1"></i> Add Sub Admin</a> -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="d-flex">
                                        <div class="col-md-2">
                                            <mat-form-field appearance="fill" class="width-webkit-fill-available">
                                                <mat-label>From date:</mat-label>
                                                <input matInput [max]="maxDate" id="fromDate" [matDatepicker]="picker"
                                                    formControlName="fromDate">
                                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                                <mat-datepicker #picker></mat-datepicker>
                                            </mat-form-field>
                                            <!-- <input type="date" id="fromDate" style="border-radius: 5px;max-width: 200px" class="form-control" formControlName="fromDate"> -->
                                        </div>
                                        <div class="col-md-2">
                                            <mat-form-field appearance="fill" class="width-webkit-fill-available">
                                                <mat-label>To Date :</mat-label>
                                                <input matInput [max]="maxDate" id="toDate" [matDatepicker]="picker1"
                                                    formControlName="toDate">
                                                <mat-datepicker-toggle matSuffix
                                                    [for]="picker1"></mat-datepicker-toggle>
                                                <mat-datepicker #picker1></mat-datepicker>
                                            </mat-form-field>
                                            <!-- <input type="date" id="toDate" style="border-radius: 5px;max-width: 200px" class="form-control" formControlName="toDate"> -->

                                        </div>
                                        <div class="col-md-8">
                                            <button type="button" (click)="getTransactionList()"
                                                class="btn btn-info ms-2" style="height: 35px;padding-top: 3px;">
                                                <i class="fa fa-search"> Search </i></button>

                                            <button class="btn btn-danger ms-2" type="button" (click)="Reset()"
                                                style="height: 35px;padding-top: 3px;">
                                                <i class="fa fa-undo"> Reset</i></button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div class="table-responsive">
                            <table class="table table-bordered" aria-describedby="">
                                <thead>
                                    <tr class="no_wrap_th text-center">
                                        <th class="Sorting-img" scope="col">S.No.</th>
                                        <th scope="col" class="Sorting-img">Transfer from</th>
                                        <!-- <th scope="col" class="Sorting-img">Transfer to</th> -->
                                        <th scope="col" class="Sorting-img">Transaction ID</th>
                                        <th scope="col" class="Sorting-img">Program Name</th>
                                        <th scope="col" class="Sorting-img">Payment Method</th>
                                        <th scope="col" class="Sorting-img">Amount</th>
                                        <th scope="col" class="Sorting-img">Date of Transaction</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    @for (item of transactionList | paginate: { itemsPerPage: itemPerPage, currentPage:
                                    currentPage, totalItems: total}; track item; let i = $index) {
                                    <tr class="text-center">
                                        <td class="content">{{itemPerPage * (currentPage -1 )+i+1}}</td>
                                        <td class="content">{{item?.userId?.firstName || '--'}} {{item?.userId?.lastName
                                            || ''}}</td>
                                        <!-- <td class="content">Abhishek</td> -->
                                        <td class="content">{{item?.transactionId || '--'}}</td>
                                        <td class="content">
                                            <abbr [title]="item?.programId?.title">
                                                {{item?.programId?.title || '--'}}
                                            </abbr>
                                        </td>
                                        <td class="content">Stripe</td>
                                        <td class="content">
                                            @if(item?.amount){
                                            <span>${{item?.amount}}</span>
                                            } @else {
                                            <span>--</span>
                                            }
                                        </td>
                                        <td class="content">{{item?.createdAt| date : 'd/M/y' :'UTC' }}</td>
                                    </tr>
                                    }
                                    @if(!transactionList.length){
                                    <tr>
                                        <td class="table-no-record" colspan="8">No Record Found</td>
                                    </tr>
                                    }
                                </tbody>
                            </table>
                            @if(total > 10){
                            <div class="custom-pagination mt-3 d-flex justify-content-end">
                                <pagination-controls (pageChange)="pagination($event)"></pagination-controls>
                            </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</div>

<!-- delete hospital modal Start -->
<div class="modal fade global-modal reset-modal" id="deleteUser">
    <div class="modal-dialog max-WT-500">
        <form class="change_password">
            <div class="modal-content">
                <div class="modal-header d-block text-center modal-header-custm">
                    <h5 class="modal-title d-inline-block">Delete Program</h5>
                </div>
                <div class="modal-inner-content">
                    <div class="modal-body">
                        <div class="text-center modal_flax_height d-flex align-items-center justify-content-center">
                            <div class="w-100">
                                <p>Are you sure you want to delete this Program?</p>
                                <div class="modal-btn-box">
                                    <button type="submit" class="btn btn-theme" data-dismiss="modal">Yes</button>
                                    <button type="button" class="btn btn-danger ms-2" style="min-width: 100px;"
                                        data-dismiss="modal">No</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>
<!-- end delete hospital modal -->